import {
  actions,
  getBusinessQuantityDatatableAsync,
  createnewBusinessQuantityAsync,
} from './slices';

export const BusinessQuantityActions = {
  ...actions,
  getBusinessQuantityDatatableAsync,
  createnewBusinessQuantityAsync,
};
